import { LegalPageLayout, COMPANY_INFO } from './LegalPage';

const MentionsLegales = () => {
  return (
    <LegalPageLayout title="Mentions légales">
      <h2>1. Éditeur du site</h2>
      <p>
        Le présent site <strong>notabenesympho.be</strong> est édité par :
      </p>
      <ul>
        <li><strong>Dénomination sociale :</strong> {COMPANY_INFO.name}</li>
        <li><strong>Nom commercial :</strong> {COMPANY_INFO.tradeName}</li>
        <li><strong>Forme juridique :</strong> {COMPANY_INFO.legalForm}</li>
        <li><strong>Adresse du siège social :</strong> {COMPANY_INFO.address}</li>
        <li><strong>Numéro d'entreprise (BCE) :</strong> {COMPANY_INFO.bce}</li>
        <li><strong>Numéro de TVA :</strong> {COMPANY_INFO.vat}</li>
        <li><strong>Téléphone :</strong> {COMPANY_INFO.phone}</li>
        <li><strong>Email :</strong> {COMPANY_INFO.email}</li>
        <li><strong>Directeur de la publication :</strong> {COMPANY_INFO.publisher}</li>
      </ul>

      <h2>2. Hébergement</h2>
      <p>
        Le site est hébergé par <strong>{COMPANY_INFO.hosting}</strong>.
      </p>

      <h2>3. Propriété intellectuelle</h2>
      <p>
        L'ensemble du contenu du site (textes, images, vidéos, logos, graphismes, charte graphique) est la propriété
        exclusive de {COMPANY_INFO.name} ou de ses partenaires et est protégé par les lois belges et internationales
        relatives à la propriété intellectuelle. Toute reproduction, représentation, modification, publication,
        transmission, dénaturation, totale ou partielle du site ou de son contenu, par quelque procédé que ce soit,
        et sur quelque support que ce soit, sans l'autorisation écrite préalable de {COMPANY_INFO.name}, est interdite
        et constitue un acte de contrefaçon sanctionné par le Code de droit économique belge.
      </p>

      <h2>4. Responsabilité</h2>
      <p>
        Les informations diffusées sur le site sont fournies à titre indicatif. Bien que {COMPANY_INFO.name} s'efforce
        de fournir des informations aussi précises que possible, des erreurs ou omissions peuvent survenir.
        {COMPANY_INFO.name} ne saurait être tenu responsable d'un quelconque dommage direct ou indirect
        résultant de l'utilisation du site.
      </p>
      <p>
        Les prix, plats et horaires peuvent être modifiés à tout moment sans préavis. Les photos des plats sont
        non contractuelles.
      </p>

      <h2>5. Liens hypertextes</h2>
      <p>
        Le site peut contenir des liens vers d'autres sites. {COMPANY_INFO.name} n'exerce aucun contrôle sur ces
        sites et décline toute responsabilité quant à leur contenu.
      </p>

      <h2>6. Droit applicable et juridiction compétente</h2>
      <p>
        Les présentes mentions légales sont régies par le droit belge. En cas de litige, et à défaut de résolution
        amiable, compétence exclusive est attribuée aux tribunaux de l'arrondissement judiciaire de Mons, Belgique.
      </p>

      <h2>7. Contact</h2>
      <p>
        Pour toute question relative aux présentes mentions légales, vous pouvez nous contacter par email à l'adresse
        suivante : <strong>{COMPANY_INFO.email}</strong>.
      </p>
    </LegalPageLayout>
  );
};

export default MentionsLegales;
